import { db } from "@/firebaseConfig";

const dessertCollection = db.collection("dessert");

const saveDessert = async data => {
  dessertCollection
    .doc()
    .set(data)
    .then(() => {
      console.log("Dessert successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const updateDessert = async (id, data) => {
  dessertCollection
    .doc(id)
    .update(data)
    .then(() => {
      console.log("Dessert successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const deleteDessert = async id => {
  dessertCollection
    .doc(id)
    .delete()
    .then(() => {
      console.log("Dessert successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const getDessertById = async id => {
  return dessertCollection
    .doc(id)
    .get()
    .then(doc => {
      return doc.exists ? doc.data() : null;
    })
    .catch(error => {
      throw error;
    });
};

const getLastDessert = async () => {
  return dessertCollection
    .orderBy("updated_on", "desc")
    .limit(1)
    .get();
};

export {
  dessertCollection,
  saveDessert,
  updateDessert,
  deleteDessert,
  getDessertById,
  getLastDessert
};
